// extracted by mini-css-extract-plugin
export default {"Wrapper":"Modal_Wrapper__mtkDa","open":"Modal_open__5Nr7u","overlay":"Modal_overlay__b+zEz","Inner":"Modal_Inner__zGHuy"};